module.exports = __webpack_public_path__ + "img/231-4fd6ea.png";